export default "__VITE_ASSET__Dm5epZgj__"